import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button/Button.js';
import { Icon } from '../../components/Icon/Icon.js';
import { Input } from '../../components/Input/Input.js';
import { Select } from '../../components/Select/Select.js';
import { Checkbox } from '../../components/Checkbox/Checkbox.js';
import { AppHeader } from '../../components/AppHeader/AppHeader.js';
import { SectionHeader } from '../../components/SectionHeader/SectionHeader.js';
import { FolderHeader } from '../../components/FolderHeader/FolderHeader.js';
import { CardColor } from '../../components/CardColor/CardColor.js';
import { SEOProtection } from '../../components/SEOProtection/SEOProtection.js';
import './Playground.css';

export const Playground = () => {
  const [theme, setTheme] = useState('dark');
  const [isThemeSwitching, setIsThemeSwitching] = useState(false);
  const [selectedState, setSelectedState] = useState('default');
  const [textInputValue, setTextInputValue] = useState('');
  const [numberInputValue, setNumberInputValue] = useState('');
  const [defaultSelectValue, setDefaultSelectValue] = useState('');
  const [colorSelectValue, setColorSelectValue] = useState('');
  const [checkbox1Checked, setCheckbox1Checked] = useState(false);
  const [checkbox2Checked, setCheckbox2Checked] = useState(true);
  const [checkbox3Checked, setCheckbox3Checked] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState('default');
  
  // Folder Header states
  const [folder1Expanded, setFolder1Expanded] = useState(true);
  const [folder1Name, setFolder1Name] = useState('Primary Colors');
  const [folder1Editing, setFolder1Editing] = useState(false);
  const [folder2Expanded, setFolder2Expanded] = useState(false);
  const [folder2Name, setFolder2Name] = useState('Secondary Colors');
  const [folder2Editing, setFolder2Editing] = useState(false);
  
  // Card Color demo no longer uses mode selection; always show 6 cards

  const toggleTheme = () => {
    if (isThemeSwitching) return;
    setIsThemeSwitching(true);
    const current = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
    const next = current === 'dark' ? 'light' : 'dark';
    const root = document.documentElement;
    const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReduced) {
      root.classList.add('theme-animating');
      root.setAttribute('data-theme', next);
      setTimeout(() => {
        root.classList.remove('theme-animating');
        setIsThemeSwitching(false);
      }, 180);
    } else {
      root.setAttribute('data-theme', next);
      setIsThemeSwitching(false);
    }
    setTheme(next);
  };

  const handleImportConfigs = () => {
    // TODO: Implement import functionality
  };

  const handleExport = () => {
    // TODO: Implement export functionality
  };

  const handleAddColor = () => {
    // TODO: Implement add color functionality
  };

  const handleAddFolder = () => {
    // TODO: Implement add folder functionality
  };

  // Folder Header handlers
  const handleFolderAddColor = (folderName) => {
    // TODO: Implement add color to folder functionality
  };

  const handleFolderAction = (folderName, action) => {
    // TODO: Implement folder actions
  };

  const buttonTypes = ['solid', 'outline', 'ghost'];
  const buttonSizes = ['small', 'medium'];
  const buttonStates = ['default', 'hover', 'pressed', 'disabled'];

  // Sample data for Select components
  const defaultOptions = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
    { value: 'option3', label: 'Option 3' },
    { value: 'static-color', label: 'Static color' }
  ];

  const colorOptions = [
    { value: 'primary', label: 'Primary Blue', color: '#006aaf' },
    { value: 'secondary', label: 'Secondary Green', color: '#00a86b' },
    { value: 'accent', label: 'Accent Orange', color: '#ff6b35' },
    { value: 'warning', label: 'Warning Yellow', color: '#ffd23f' },
    { value: 'error', label: 'Error Red', color: '#ff4757' }
  ];

  // Sample theme options for SectionHeader
  const themeOptions = [
    { value: 'default', label: 'Default' },
    { value: 'brand', label: 'Brand' },
    { value: 'minimal', label: 'Minimal' },
    { value: 'vivid', label: 'Vivid' }
  ];

  return (
    <div className="playground">
      <SEOProtection noIndex={true} />
      <header className="playground__header">
        <h1 className="playground__title">Component Playground</h1>
        <nav className="playground__nav">
          <a href="#appheader" className="playground__nav-link">App Header</a>
          <a href="#sectionheader" className="playground__nav-link">Section Header</a>
          <a href="#folderheader" className="playground__nav-link">Folder Header</a>
          <a href="#cardcolor" className="playground__nav-link">Card Color</a>
          <a href="#icons" className="playground__nav-link">Icons</a>
          <a href="#buttons" className="playground__nav-link">Buttons</a>
          <a href="#inputs" className="playground__nav-link">Inputs</a>
          <a href="#select" className="playground__nav-link">Select</a>
          <a href="#checkbox" className="playground__nav-link">Checkbox</a>
          <a href="#typography" className="playground__nav-link">Typography</a>
        </nav>
        <div className="playground__controls">
          <Link to="/r9w-c5l7r3s" className="playground__back-link">
            <Button
              type="ghost"
              size="medium"
              icon={<Icon name="chevron-right" size="medium" />}
              className="playground__back-button"
            >
              Back to Main
            </Button>
          </Link>
          <Button
            type="ghost"
            size="medium"
            icon={<Icon name="dark-mode" size="medium" />}
            onClick={toggleTheme}
            disabled={isThemeSwitching}
          >
            {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
          </Button>
        </div>
      </header>

      <main className="playground__main">
        <section className="playground__section" id="appheader">
          <h2 className="playground__section-title">App Header Component</h2>
          <p className="playground__description">
            Application header with logo, theme switcher, and action buttons.
          </p>
          
          <div className="playground__appheader-demo">
            <div className="playground__appheader-container">
              <AppHeader
                currentTheme={theme}
                onThemeToggle={toggleTheme}
                isThemeSwitching={isThemeSwitching}
                onImportConfigs={handleImportConfigs}
                onExport={handleExport}
              />
            </div>
            
            <div className="playground__appheader-info">
              <h3 className="playground__appheader-info-title">Features</h3>
              <ul className="playground__appheader-features">
                <li>• Logo display (RaW Colors)</li>
                <li>• Theme switcher (Ghost button with icon only)</li>
                <li>• Import configs (Outline button with icon and text)</li>
                <li>• Export (Solid button with icon and text)</li>
                <li>• Responsive design with mobile optimizations</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="playground__section" id="sectionheader">
          <h2 className="playground__section-title">Section Header Component</h2>
          <p className="playground__description">
            Section header with title, theme selector, and action buttons for content management.
          </p>
          
          <div className="playground__sectionheader-demo">
            <div className="playground__sectionheader-container">
              <SectionHeader
                title="Colors"
                selectedTheme={selectedTheme}
                themeOptions={themeOptions}
                onThemeChange={(option) => setSelectedTheme(option.value)}
                onAddColor={handleAddColor}
                onAddFolder={handleAddFolder}
              />
            </div>
            
            <div className="playground__sectionheader-variants">
              <h3 className="playground__sectionheader-variant-title">Variants</h3>
              
              <div className="playground__sectionheader-variant">
                <h4 className="playground__variant-label">Without Theme Selector</h4>
                <div className="playground__sectionheader-container">
                  <SectionHeader
                    title="Settings"
                    showThemeSelect={false}
                    onAddColor={handleAddColor}
                    onAddFolder={handleAddFolder}
                  />
                </div>
              </div>
              
              <div className="playground__sectionheader-variant">
                <h4 className="playground__variant-label">Long Title</h4>
                <div className="playground__sectionheader-container">
                  <SectionHeader
                    title="Very Long Section Title That Should Truncate"
                    selectedTheme={selectedTheme}
                    themeOptions={themeOptions}
                    onThemeChange={(option) => setSelectedTheme(option.value)}
                    onAddColor={handleAddColor}
                    onAddFolder={handleAddFolder}
                  />
                </div>
              </div>
            </div>
            
            <div className="playground__sectionheader-info">
              <h3 className="playground__sectionheader-info-title">Features</h3>
              <ul className="playground__sectionheader-features">
                <li>• Large title with proper typography</li>
                <li>• Optional theme selector (for token themes)</li>
                <li>• Add color action button</li>
                <li>• Add folder action button</li>
                <li>• Responsive design with mobile optimizations</li>
                <li>• Title truncation for long text</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="playground__section" id="folderheader">
          <h2 className="playground__section-title">Folder Header Component</h2>
          <p className="playground__description">
            Interactive folder headers with expand/collapse, editable names, and dropdown actions.
          </p>
          
          <div className="playground__folderheader-demo">
            <div className="playground__folderheader-container">
              <FolderHeader
                folderName={folder1Name}
                isExpanded={folder1Expanded}
                isEditing={folder1Editing}
                onToggleExpanded={setFolder1Expanded}
                onNameChange={setFolder1Name}
                onStartEditing={() => setFolder1Editing(true)}
                onStopEditing={() => setFolder1Editing(false)}
                onAddColor={() => handleFolderAddColor(folder1Name)}
                onExpandCollapse={() => setFolder1Expanded(!folder1Expanded)}
                onRename={() => setFolder1Editing(true)}
                onMoveUp={() => handleFolderAction(folder1Name, 'move-up')}
                onMoveDown={() => handleFolderAction(folder1Name, 'move-down')}
                onDelete={() => handleFolderAction(folder1Name, 'delete')}
              />
              
              <FolderHeader
                folderName={folder2Name}
                isExpanded={folder2Expanded}
                isEditing={folder2Editing}
                onToggleExpanded={setFolder2Expanded}
                onNameChange={setFolder2Name}
                onStartEditing={() => setFolder2Editing(true)}
                onStopEditing={() => setFolder2Editing(false)}
                onAddColor={() => handleFolderAddColor(folder2Name)}
                onExpandCollapse={() => setFolder2Expanded(!folder2Expanded)}
                onRename={() => setFolder2Editing(true)}
                onMoveUp={() => handleFolderAction(folder2Name, 'move-up')}
                onMoveDown={() => handleFolderAction(folder2Name, 'move-down')}
                onDelete={() => handleFolderAction(folder2Name, 'delete')}
              />
            </div>
            
            <div className="playground__folderheader-info">
              <h3 className="playground__folderheader-info-title">Features</h3>
              <ul className="playground__folderheader-features">
                <li>• Smart expand/collapse button with hover state icons</li>
                <li>• Click-to-edit folder names with ghost input styling</li>
                <li>• Add color action button</li>
                <li>• More actions dropdown with contextual options</li>
                <li>• Keyboard support (Enter/Escape for name editing)</li>
                <li>• Responsive design with mobile optimizations</li>
                <li>• Auto-close dropdown when clicking outside</li>
              </ul>
              
              <h4 className="playground__folderheader-interaction-title">Interactions</h4>
              <ul className="playground__folderheader-interactions">
                <li>• <strong>Folder Icon:</strong> Click to expand/collapse, hover to see expand hint</li>
                <li>• <strong>Folder Name:</strong> Click to edit inline</li>
                <li>• <strong>Add Button:</strong> Add new color to this folder</li>
                <li>• <strong>More Menu:</strong> Access folder management actions</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="playground__section" id="cardcolor">
          <h2 className="playground__section-title">Card Color Component</h2>
          <p className="playground__description">
            Complex color configuration cards with multiple modes and responsive layout.
          </p>
          
          <div className="playground__cardcolor-demo">
            <div className="playground__cardcolor-examples">
              <h3 className="playground__cardcolor-examples-title">Examples</h3>

              {/* Default cards */}
              <div className="playground__cardcolor-container">
                <CardColor
                  mode="static"
                  colorName="Primary Blue"
                  colorValue="#34B9FF"
                  oklchValue="oklch(0.5 0.25 240)"
                  p3Support={true}
                />
              </div>

              <div className="playground__cardcolor-container">
                <CardColor
                  mode="linked"
                  colorName="Accent Orange"
                  colorValue="#ff6b35"
                  oklchValue="oklch(0.6 0.15 45)"
                  p3Support={false}
                />
              </div>

              <div className="playground__cardcolor-container">
                <CardColor
                  mode="contrast"
                  colorName="Success Green"
                  colorValue="#00a86b"
                  oklchValue="oklch(0.55 0.12 140)"
                  p3Support={true}
                />
              </div>

              {/* Waitlist demo variant cards */}
              <div className="playground__cardcolor-container">
                <CardColor
                  variant="demo"
                  mode="static"
                  colorName="Primary Blue"
                  colorValue="#34B9FF"
                  oklchValue="oklch(0.5 0.25 240)"
                  p3Support={true}
                />
              </div>

              <div className="playground__cardcolor-container">
                <CardColor
                  variant="demo"
                  mode="linked"
                  colorName="Accent Orange"
                  colorValue="#ff6b35"
                  oklchValue="oklch(0.6 0.15 45)"
                  p3Support={false}
                />
              </div>

              <div className="playground__cardcolor-container">
                <CardColor
                  variant="demo"
                  mode="contrast"
                  colorName="Success Green"
                  colorValue="#00a86b"
                  oklchValue="oklch(0.55 0.12 140)"
                  p3Support={true}
                />
              </div>
            </div>
            
            <div className="playground__cardcolor-info">
              <h3 className="playground__cardcolor-info-title">Features</h3>
              <ul className="playground__cardcolor-features">
                <li>• <strong>Three Color Modes:</strong> Static, Linked, and Contrast-based</li>
                <li>• <strong>Responsive Layout:</strong> Auto-wrapping content with flex-wrap</li>
                <li>• <strong>Fixed Dimensions:</strong> Type & Name (min 200px), Parameters (440-640px), Swatch (168px)</li>
                <li>• <strong>OKLCH Support:</strong> Modern color space with L, C, H, A controls</li>
                <li>• <strong>P3 Color Space:</strong> Display-P3 wide gamut support indicator</li>
                <li>• <strong>Color References:</strong> Link to other colors for dynamic relationships</li>
                <li>• <strong>Contrast Controls:</strong> Background/Foreground contrast calculations</li>
                <li>• <strong>Mobile Responsive:</strong> Stack layout on smaller screens</li>
              </ul>
              
              <h4 className="playground__cardcolor-modes-title">Color Modes</h4>
              <ul className="playground__cardcolor-modes">
                <li>• <strong>Static Color:</strong> Direct color value input (OKLCH format)</li>
                <li>• <strong>Linked Color:</strong> Reference another color with OKLCH adjustments</li>
                <li>• <strong>Contrast-based:</strong> Calculate color based on contrast ratio requirements</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="playground__section" id="icons">
          <h2 className="playground__section-title">Icon Gallery</h2>
          <p className="playground__description">
            All available icons in different sizes.
          </p>
          
          <div className="playground__icon-gallery">
            <div className="playground__icon-size-group">
              <h3 className="playground__icon-size-title">Small Icons (16px)</h3>
              <div className="playground__icon-grid">
                <div className="playground__icon-item">
                  <Icon name="add" size="small" />
                  <span className="playground__icon-name">add</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="check" size="small" />
                  <span className="playground__icon-name">check</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="download" size="small" />
                  <span className="playground__icon-name">download</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="upload" size="small" />
                  <span className="playground__icon-name">upload</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="expand-more" size="small" />
                  <span className="playground__icon-name">expand-more</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="more-vert" size="small" />
                  <span className="playground__icon-name">more-vert</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="folder" size="small" />
                  <span className="playground__icon-name">folder</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="create-new-folder" size="small" />
                  <span className="playground__icon-name">create-new-folder</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="stat-1" size="small" />
                  <span className="playground__icon-name">stat-1</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="stat-minus-1" size="small" />
                  <span className="playground__icon-name">stat-minus-1</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="dark-mode" size="small" />
                  <span className="playground__icon-name">dark-mode</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="light-mode" size="small" />
                  <span className="playground__icon-name">light-mode</span>
                </div>
              </div>
            </div>

            <div className="playground__icon-size-group">
              <h3 className="playground__icon-size-title">Medium Icons (24px)</h3>
              <div className="playground__icon-grid">
                <div className="playground__icon-item">
                  <Icon name="add" size="medium" />
                  <span className="playground__icon-name">add</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="check" size="medium" />
                  <span className="playground__icon-name">check</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="download" size="medium" />
                  <span className="playground__icon-name">download</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="upload" size="medium" />
                  <span className="playground__icon-name">upload</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="expand-more" size="medium" />
                  <span className="playground__icon-name">expand-more</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="more-vert" size="medium" />
                  <span className="playground__icon-name">more-vert</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="folder" size="medium" />
                  <span className="playground__icon-name">folder</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="create-new-folder" size="medium" />
                  <span className="playground__icon-name">create-new-folder</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="stat-1" size="medium" />
                  <span className="playground__icon-name">stat-1</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="stat-minus-1" size="medium" />
                  <span className="playground__icon-name">stat-minus-1</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="dark-mode" size="medium" />
                  <span className="playground__icon-name">dark-mode</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="light-mode" size="medium" />
                  <span className="playground__icon-name">light-mode</span>
                </div>
              </div>
            </div>

            <div className="playground__icon-size-group">
              <h3 className="playground__icon-size-title">Large Icons (32px)</h3>
              <div className="playground__icon-grid">
                <div className="playground__icon-item">
                  <Icon name="add" size="large" />
                  <span className="playground__icon-name">add</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="check" size="large" />
                  <span className="playground__icon-name">check</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="download" size="large" />
                  <span className="playground__icon-name">download</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="upload" size="large" />
                  <span className="playground__icon-name">upload</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="expand-more" size="large" />
                  <span className="playground__icon-name">expand-more</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="more-vert" size="large" />
                  <span className="playground__icon-name">more-vert</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="folder" size="large" />
                  <span className="playground__icon-name">folder</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="create-new-folder" size="large" />
                  <span className="playground__icon-name">create-new-folder</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="stat-1" size="large" />
                  <span className="playground__icon-name">stat-1</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="stat-minus-1" size="large" />
                  <span className="playground__icon-name">stat-minus-1</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="dark-mode" size="large" />
                  <span className="playground__icon-name">dark-mode</span>
                </div>
                <div className="playground__icon-item">
                  <Icon name="light-mode" size="large" />
                  <span className="playground__icon-name">light-mode</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="playground__section" id="buttons">
          <h2 className="playground__section-title">Interactive Buttons</h2>
          <p className="playground__description">
            These buttons respond to real hover and click interactions.
          </p>
          
          <div className="playground__grid">
            {buttonTypes.map(type => (
              <div key={type} className="playground__type-group">
                <h3 className="playground__type-title">{type.charAt(0).toUpperCase() + type.slice(1)}</h3>
                <div className="playground__buttons">
                  {buttonSizes.map(size => (
                    <div key={size} className="playground__size-group">
                      <h4 className="playground__size-title">{size.charAt(0).toUpperCase() + size.slice(1)}</h4>
                      <div className="playground__button-row">
                        <Button
                          type={type}
                          size={size}
                          icon={<Icon name="add" size={size} />}
                        >
                          Button
                        </Button>
                        <Button
                          type={type}
                          size={size}
                          icon={<Icon name="download" size={size} />}
                        >
                          Download
                        </Button>
                        <Button
                          type={type}
                          size={size}
                        >
                          Text Only
                        </Button>
                        <Button
                          type={type}
                          size={size}
                          icon={<Icon name="check" size={size} />}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="playground__section">
          <h2 className="playground__section-title">State Preview</h2>
          <p className="playground__description">
            Select a state to see how buttons look in different states. The "Disabled" state shows buttons with reduced opacity and disabled interactions.
          </p>
          
          <div className="playground__state-controls">
            {buttonStates.map(state => (
              <Button
                key={state}
                type={selectedState === state ? 'solid' : 'ghost'}
                size="small"
                onClick={() => setSelectedState(state)}
              >
                {state.charAt(0).toUpperCase() + state.slice(1)}
              </Button>
            ))}
          </div>

          <div className="playground__grid">
            {buttonTypes.map(type => (
              <div key={type} className="playground__type-group">
                <h3 className="playground__type-title">{type.charAt(0).toUpperCase() + type.slice(1)}</h3>
                <div className="playground__buttons">
                  {buttonSizes.map(size => (
                    <div key={size} className="playground__size-group">
                      <h4 className="playground__size-title">{size.charAt(0).toUpperCase() + size.slice(1)}</h4>
                      <div className="playground__button-row">
                        <Button
                          type={type}
                          size={size}
                          state={selectedState === 'disabled' ? 'default' : selectedState}
                          disabled={selectedState === 'disabled'}
                          icon={<Icon name="add" size={size} />}
                        >
                          Button
                        </Button>
                        <Button
                          type={type}
                          size={size}
                          state={selectedState === 'disabled' ? 'default' : selectedState}
                          disabled={selectedState === 'disabled'}
                          icon={<Icon name="download" size={size} />}
                        >
                          Download
                        </Button>
                        <Button
                          type={type}
                          size={size}
                          state={selectedState === 'disabled' ? 'default' : selectedState}
                          disabled={selectedState === 'disabled'}
                        >
                          Text Only
                        </Button>
                        <Button
                          type={type}
                          size={size}
                          state={selectedState === 'disabled' ? 'default' : selectedState}
                          disabled={selectedState === 'disabled'}
                          icon={<Icon name="check" size={size} />}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="playground__section" id="inputs">
          <h2 className="playground__section-title">Input Components</h2>
          <p className="playground__description">
            Text and Number inputs with Outline and Ghost styles.
          </p>
          
          <div className="playground__input-grid">
            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Text Inputs</h3>
              <div className="playground__input-row">
                <div className="playground__input-item">
                  <Input
                    type="text"
                    style="outline"
                    label="Outline Style"
                    placeholder="Enter text..."
                    value={textInputValue}
                    onChange={(e) => setTextInputValue(e.target.value)}
                  />
                </div>
                <div className="playground__input-item">
                  <Input
                    type="text"
                    style="ghost"
                    label="Ghost Style"
                    placeholder="Enter text..."
                    value={textInputValue}
                    onChange={(e) => setTextInputValue(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Number Inputs</h3>
              <div className="playground__input-row">
                <div className="playground__input-item">
                  <Input
                    type="number"
                    style="outline"
                    label="Outline Style"
                    placeholder="Enter number..."
                    value={numberInputValue}
                    onChange={(e) => setNumberInputValue(e.target.value)}
                  />
                </div>
                <div className="playground__input-item">
                  <Input
                    type="number"
                    style="ghost"
                    label="Ghost Style"
                    placeholder="Enter number..."
                    value={numberInputValue}
                    onChange={(e) => setNumberInputValue(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Disabled States</h3>
              <div className="playground__input-row">
                <div className="playground__input-item">
                  <Input
                    type="text"
                    style="outline"
                    label="Disabled Outline"
                    placeholder="Disabled input..."
                    disabled={true}
                  />
                </div>
                <div className="playground__input-item">
                  <Input
                    type="text"
                    style="ghost"
                    label="Disabled Ghost"
                    placeholder="Disabled input..."
                    disabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="playground__section" id="select">
          <h2 className="playground__section-title">Select Components</h2>
          <p className="playground__description">
            Default and Color selects with Outline and Ghost styles.
          </p>
          
          <div className="playground__input-grid">
            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Default Selects</h3>
              <div className="playground__input-row">
                <div className="playground__input-item">
                  <Select
                    type="default"
                    style="outline"
                    label="Outline Style"
                    options={defaultOptions}
                    value={defaultSelectValue}
                    onChange={(option) => setDefaultSelectValue(option.value)}
                    placeholder="Select option..."
                  />
                </div>
                <div className="playground__input-item">
                  <Select
                    type="default"
                    style="ghost"
                    label="Ghost Style"
                    options={defaultOptions}
                    value={defaultSelectValue}
                    onChange={(option) => setDefaultSelectValue(option.value)}
                    placeholder="Static color"
                  />
                </div>
              </div>
            </div>

            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Color Selects</h3>
              <div className="playground__input-row">
                <div className="playground__input-item">
                  <Select
                    type="color"
                    style="outline"
                    label="Outline Style"
                    options={colorOptions}
                    value={colorSelectValue}
                    onChange={(option) => setColorSelectValue(option.value)}
                    placeholder="Select color..."
                  />
                </div>
                <div className="playground__input-item">
                  <Select
                    type="color"
                    style="ghost"
                    label="Ghost Style"
                    options={colorOptions}
                    value={colorSelectValue}
                    onChange={(option) => setColorSelectValue(option.value)}
                    placeholder="Color name"
                  />
                </div>
              </div>
            </div>

            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Disabled States</h3>
              <div className="playground__input-row">
                <div className="playground__input-item">
                  <Select
                    type="default"
                    style="outline"
                    label="Disabled Default"
                    options={defaultOptions}
                    placeholder="Disabled select..."
                    disabled={true}
                  />
                </div>
                <div className="playground__input-item">
                  <Select
                    type="color"
                    style="outline"
                    label="Disabled Color"
                    options={colorOptions}
                    placeholder="Disabled select..."
                    disabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="playground__section" id="checkbox">
          <h2 className="playground__section-title">Checkbox Components</h2>
          <p className="playground__description">
            Interactive checkboxes with labels and different states.
          </p>
          
          <div className="playground__input-grid">
            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Interactive Checkboxes</h3>
              <div className="playground__checkbox-row">
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={checkbox1Checked}
                    onChange={setCheckbox1Checked}
                    label="Unchecked option"
                  />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={checkbox2Checked}
                    onChange={setCheckbox2Checked}
                    label="Checked option"
                  />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={checkbox3Checked}
                    onChange={setCheckbox3Checked}
                    label="Another option"
                  />
                </div>
              </div>
            </div>

            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Checkbox States</h3>
              <div className="playground__checkbox-row">
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={false}
                    label="Default unchecked"
                  />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={true}
                    label="Default checked"
                  />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={false}
                    disabled={true}
                    label="Disabled unchecked"
                  />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox
                    checked={true}
                    disabled={true}
                    label="Disabled checked"
                  />
                </div>
              </div>
            </div>

            <div className="playground__input-group">
              <h3 className="playground__input-group-title">Without Labels</h3>
              <div className="playground__checkbox-row">
                <div className="playground__checkbox-item">
                  <Checkbox checked={false} />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox checked={true} />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox checked={false} disabled={true} />
                </div>
                <div className="playground__checkbox-item">
                  <Checkbox checked={true} disabled={true} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="playground__section" id="typography">
          <h2 className="playground__section-title">Typography</h2>
          <p className="playground__description">
            Complete typography system with font sizes and weights in a 3x3 grid.
          </p>
          
          <div className="playground__typography-demo">
            <div className="playground__typography-grid">
              {/* Header row with font weights */}
              <div className="playground__typography-header">
                <div className="playground__typography-cell playground__typography-cell--header"></div>
                <div className="playground__typography-cell playground__typography-cell--header">
                  <span className="playground__typography-weight-label">Regular</span>
                  <span className="playground__typography-weight-value">300/400/500</span>
                </div>
                <div className="playground__typography-cell playground__typography-cell--header">
                  <span className="playground__typography-weight-label">Semi-Bold</span>
                  <span className="playground__typography-weight-value">400/500/600</span>
                </div>
                <div className="playground__typography-cell playground__typography-cell--header">
                  <span className="playground__typography-weight-label">Bold</span>
                  <span className="playground__typography-weight-value">600/700</span>
                </div>
              </div>
              
              {/* Font size rows (Small, Medium, Extra Large) */}
              <div className="playground__typography-row">
                <div className="playground__typography-cell playground__typography-cell--label">
                  <span className="playground__typography-size-label">Small</span>
                  <span className="playground__typography-size-value">12px</span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--small playground__typography-sample--regular">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--small playground__typography-sample--semi-bold">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--small playground__typography-sample--bold">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
              </div>
              
              <div className="playground__typography-row">
                <div className="playground__typography-cell playground__typography-cell--label">
                  <span className="playground__typography-size-label">Medium</span>
                  <span className="playground__typography-size-value">14px</span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--medium playground__typography-sample--regular">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--medium playground__typography-sample--semi-bold">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--medium playground__typography-sample--bold">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
              </div>
              
              <div className="playground__typography-row">
                <div className="playground__typography-cell playground__typography-cell--label">
                  <span className="playground__typography-size-label">Extra Large</span>
                  <span className="playground__typography-size-value">24px</span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--extra-large playground__typography-sample--regular">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--extra-large playground__typography-sample--semi-bold">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
                <div className="playground__typography-cell">
                  <span className="playground__typography-sample playground__typography-sample--extra-large playground__typography-sample--bold">
                    The quick brown fox jumps over the lazy dog
                  </span>
                </div>
              </div>
            </div>
            
            <div className="playground__typography-info">
              <h3 className="playground__typography-info-title">Typography System</h3>
              <ul className="playground__typography-features">
                <li>• <strong>3 Font Sizes:</strong> Small (12px), Medium (14px), Extra Large (24px)</li>
                <li>• <strong>3 Font Weights:</strong> Regular, Semi-Bold, Bold</li>
                <li>• <strong>Theme Adaptive:</strong> Weights adjust between dark and light modes, with browser tweaks</li>
                <li>• <strong>Font Family:</strong> Geist Mono for body, Geist for headings</li>
                <li>• <strong>Line Heights:</strong> 16px, 20px, 32px</li>
              </ul>
              
              <h4 className="playground__typography-interaction-title">Usage</h4>
              <ul className="playground__typography-usage">
                <li>• <strong>Small:</strong> Secondary text, form labels, metadata</li>
                <li>• <strong>Medium:</strong> Body text, primary content</li>
                <li>• <strong>Extra Large:</strong> Headings, titles, emphasis</li>
              </ul>
            </div>
          </div>
        </section>

      </main>
    </div>
  );
};
